module.exports = __webpack_public_path__ + "img/20180815_145537_017.8acdae4e.jpg";